import { render, staticRenderFns } from "./MyPlanFavorite.vue?vue&type=template&id=761efba5&scoped=true"
import script from "./MyPlanFavorite.vue?vue&type=script&lang=js"
export * from "./MyPlanFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761efba5",
  null
  
)

export default component.exports